<div class="general-knowledge-store-box">
    <div class="row ml-3" *ngIf="gksLibrary?.length > 0">
        <div class="mb-1" [ngClass]="gksLevel == 'topicLevel' ? 'col-md-4' : 'col-md-3'" *ngFor="let gksLibraryFolder of gksLibrary; let i = index">
            <div class="row">
                <div class="col-sm-12 d-flex" [ngClass]="{ disabledDiv: !showPKSPermissionAccess && gksLibraryFolder.id == 'ba6b7658-984f-34ae-bbe6-c755c8c645b7' }">
                    <div class="flex-start checkbox-ks">
                        <input
                            type="checkbox"
                            [(ngModel)]="gksLibraryFolder.checked"
                            (change)="isAllSelected(gksLibraryFolder, gksLibraryFolder.id)"
                            class="cursor-pointer flex-start"
                            [attr.id]="'gksLibraryFolder-checked-' + i"
                            [attr.data-test]="'gksLibraryFolder-checked-' + i"
                        />
                    </div>
                    <div
                        class="gyan-knowledge-store-list-icon ml-2"
                        title="{{ gksLibraryFolder.name }}"
                        [attr.id]="'gksLibraryFolder-name-' + gksLibraryFolder.id"
                        [attr.data-test]="'gksLibraryFolder-name-' + gksLibraryFolder.id"
                        (click)="showPopup(gksLibraryFolder, content)"
                        *ngIf="gksLibraryFolder.siteName === ''"
                    ></div>
                    <div
                        class="gyan-knowledge-store-list-icon ml-2"
                        title="{{ gksLibraryFolder.name }}"
                        [attr.id]="'gksLibraryFolder-name-' + gksLibraryFolder.id"
                        [attr.data-test]="'gksLibraryFolder-name-' + gksLibraryFolder.id"
                        (click)="showPopup(gksLibraryFolder, mkscontent)"
                        *ngIf="gksLibraryFolder.siteName !== ''"
                    ></div>
                    <div class="gyan-knowledge-store-name mr-2 displayNameMobile" title="{{ gksLibraryFolder.name }}">{{ gksLibraryFolder.name | truncate: 16 }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header d-flex">
        <div class="modal-title">Select Tags</div>
        <div type="button" class="gyan-popup-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body">
        <div class="infoPanel">
            <div class="panel-header d-flex justify-content-between">
                {{ selectedGyanKnowledgeStore.name }}
            </div>
            <div class="panel-body">
                <div class="row" *ngIf="apiResponseKeys().length == 0 && isLoadingTags">
                    <div class="col-6">
                        <div class="font-14">No Tags Available</div>
                    </div>
                </div>
                <form [formGroup]="form" *ngIf="apiResponseKeys().length > 0">
                    <div class="row" *ngIf="isLoadingTags">
                        <div class="col-6">
                            <div class="font-14">Tags</div>
                        </div>
                        <div class="col-6 include-subtopic-text font-14" *ngIf="gksLevel == 'topicLevel'">
                            <input
                                type="checkbox"
                                formControlName="isIncludeSubtopic"
                                (change)="IncludeSubtopic(selectedGyanKnowledgeStore.id, false, false)"
                                class="cursor-pointer flex-start include-subtopic"
                            />
                            Include Subtopic
                        </div>
                    </div>
                    <div class="d-flex justify-content-center py-3" *ngIf="!isLoadingTags">
                        <div class="loader-class"><span class=" ">Please wait</span><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                    </div>
                    <div *ngIf="isLoadingTags">
                        <div
                            class="gyan-knowledge-store-form"
                            [ngClass]="{ 'form-divider-mobile': isMobile && field.get('dataType')?.value !== '' }"
                            formArrayName="fields"
                            *ngFor="let field of fields.controls; let i = index"
                        >
                            <div [formGroupName]="i">
                                <div class="row mt-3">
                                    <div class="col-12 col-sm-4">
                                        <div class="form-group">
                                            <select class="form-control form-control-color" id="keySelect" formControlName="key" (change)="onKeyChange(i)">
                                                <option value="">Select Tags</option>
                                                <option *ngFor="let key of apiResponseKeys()" [value]="key.tagName" [disabled]="isKeyDisabled(key.tagName)">
                                                    {{ key.displayName }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-7" [ngClass]="{ formgroupMobile: isMobile }">
                                        <div class="form-group autocomplete-box-mobile" *ngIf="field.get('dataType')?.value === 'Text'">
                                            <!---->
                                            <div class="form-group autocomplete-box">
                                                <div class="input-with-chips">
                                                    <div class="selected-options">
                                                        <!-- looping to show selected items -->
                                                        <!-- starting showing some badges -->

                                                        <ng-container *ngFor="let option of field.get('selectedOptions')?.value; let j = index">
                                                            <!-- displaying badge according to the maxVisibleBadges limit -->
                                                            <span
                                                                *ngIf="j < maxVisibleBadges"
                                                                class="badge badge-primary mr-1"
                                                                [attr.id]="'selected-options-' + j"
                                                                [attr.data-test]="'selected-options-' + j"
                                                                title="{{ option }}"
                                                            >
                                                                {{ option | truncate: 7 }}
                                                                <span
                                                                    class="fas fa-times-circle ml-1"
                                                                    [attr.id]="'remove-option-' + j"
                                                                    [attr.data-test]="'remove-option-' + j"
                                                                    (click)="remove(option, i)"
                                                                    style="cursor: pointer"
                                                                    >&times;</span
                                                                >
                                                            </span>
                                                        </ng-container>

                                                        <!-- show +count badges -->
                                                        <span
                                                            *ngIf="field.get('selectedOptions')?.value.length > maxVisibleBadges"
                                                            class="badge badge-secondary"
                                                            [title]="getHiddenOptionsTitle(field.get('selectedOptions')?.value)"
                                                            [attr.id]="'maxVisible-Badges-' + i"
                                                            [attr.data-test]="'maxVisible-Badges-' + i"
                                                        >
                                                            +{{ field.get('selectedOptions')?.value.length - maxVisibleBadges }}
                                                        </span>

                                                        <input
                                                            type="text"
                                                            class="input-box"
                                                            placeholder="Start typing..."
                                                            formControlName="optionCtrl"
                                                            (input)="filterOptions(i)"
                                                            (focus)="onFocus(i)"
                                                            (keydown.backspace)="removeLastSelected(i)"
                                                            [attr.id]="'filter-options-' + i"
                                                            [attr.data-test]="'filter-options-' + i"
                                                        />
                                                    </div>
                                                </div>
                                                <!-- dropdown with filtered options ----  field.get('filteredOptions')?.value.length > 0 -->
                                                <ul class="list-group" *ngIf="field.get('showDropdown')?.value">
                                                    <li
                                                        class="list-group-item"
                                                        *ngFor="let option of field.get('filteredOptions')?.value"
                                                        (click)="selectOption(option, i); $event.stopPropagation()"
                                                        style="cursor: pointer"
                                                        [attr.id]="'filtered-options-' + i"
                                                        [attr.data-test]="'filtered-options-' + i"
                                                    >
                                                        {{ option }}
                                                    </li>
                                                    <!-- Show 'No result found' if there are no options left after filtering -->
                                                    <li class="list-group-item disabled" *ngIf="field.get('filteredOptions')?.value.length == 0">No result found</li>
                                                </ul>
                                            </div>

                                            <!-- <div *ngIf="field.get('dataType')?.value === 'Text'" class="form-group">
                                                <ng-select
                                                    [items]="apiResponse[field.get('key')?.value]?.value"
                                                    [multiple]="true"
                                                    bindLabel="value"
                                                    formControlName="value"
                                                    [closeOnSelect]="false"
                                                >
                                                </ng-select>
                                            </div> -->
                                        </div>
                                        <div *ngIf="field.get('dataType')?.value === 'Date'" class="form-group" [ngClass]="{ 'col-11 datepicker-mobile': isMobile }">
                                            <div class="" [ngClass]="isMobile ? ' d-flex align-items-center justify-content-between' : 'row'">
                                                <div class="col-5 col-sm-5">
                                                    <input
                                                        type="date"
                                                        class="form-control form-control-option"
                                                        id="session-date"
                                                        name="session-date"
                                                        formControlName="dateFieldFrom"
                                                        [max]="maxDateFrom"
                                                        (change)="onDateFromChange($event)"
                                                        [attr.data-test]="'from-date-' + i"
                                                    />
                                                </div>
                                                <span class="col-1 col-sm-2 to-class" [ngClass]="{ formToMobile: isMobile }">To</span>
                                                <div class="col-5 col-sm-5 pl-0">
                                                    <input
                                                        type="date"
                                                        class="form-control form-control-option"
                                                        formControlName="dateFieldTo"
                                                        (change)="onDateToChange($event)"
                                                        [min]="minDateTo"
                                                        [attr.id]="'to-date-' + i"
                                                        [attr.data-test]="'to-date-' + i"
                                                    />
                                                </div>
                                            </div>
                                            <!-- <input type="date" class="form-control" id="dateInput" formControlName="value" /> -->
                                        </div>
                                        <div
                                            class="col-1 gyan-knowledge-store-delete-icon ml-2"
                                            *ngIf="shouldShowDeleteButton(i) && isMobile"
                                            [attr.id]="'remove-field-' + i"
                                            [attr.data-test]="'remove-field-' + i"
                                            (click)="removeFormField(i)"
                                        ></div>
                                    </div>
                                    <div class="col-1 col-sm-1" *ngIf="!isMobile">
                                        <div
                                            class="gyan-knowledge-store-delete-icon ml-2"
                                            *ngIf="shouldShowDeleteButton(i)"
                                            [attr.id]="'remove-field-' + i"
                                            [attr.data-test]="'remove-field-' + i"
                                            (click)="removeFormField(i)"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="modal-footer border-0" [ngClass]="{ 'save-mobile-btn': isMobile }">
        <button
            type="button"
            class="btn-custom btn-primary mr-3 mt-0 cursor-pointer col-sm-2 float-end"
            [attr.id]="'save-local-' + selectedGyanKnowledgeStore.id"
            [attr.data-test]="'save-local-' + selectedGyanKnowledgeStore.id"
            (click)="saveFormToLocalStorage(selectedGyanKnowledgeStore.id)"
        >
            Save
        </button>
    </div>
</ng-template>

<ng-template #mkscontent let-modal>
    <div class="modal-header d-flex">
        <div class="modal-title">Select Tags</div>
        <div type="button" class="gyan-popup-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body">
        <div class="infoPanel">
            <div class="panel-header d-flex justify-content-between">
                {{ selectedGyanKnowledgeStore.name }}
            </div>
            <div class="panel-body">
                <form [formGroup]="form">
                    <div class="row" *ngIf="apiResponseKeys().length == 0 && isLoadingTags">
                        <div class="col-6">
                            <div class="font-14">No Tags Available</div>
                        </div>
                    </div>
                    <div class="row" *ngIf="isLoadingTags">
                        <div class="col-6">
                            <div class="font-14">Tags</div>
                        </div>
                        <div class="col-6 include-subtopic-text font-14" *ngIf="gksLevel == 'topicLevel'">
                            <input
                                type="checkbox"
                                formControlName="isIncludeSubtopic"
                                (change)="IncludeSubtopic(selectedGyanKnowledgeStore.id, false, false)"
                                class="cursor-pointer flex-start include-subtopic"
                            />
                            Include Subtopic
                        </div>
                    </div>
                    <div class="d-flex justify-content-center py-3" *ngIf="!isLoadingTags">
                        <div class="loader-class"><span class=" ">Please wait</span><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                    </div>
                    <div *ngIf="isLoadingTags">
                        <div
                            class="my-knowledge-store-form"
                            [ngClass]="{ 'form-divider-mobile': isMobile && field.get('dataType')?.value !== '' }"
                            formArrayName="fields"
                            *ngFor="let field of fields.controls; let i = index"
                        >
                            <div [formGroupName]="i">
                                <div class="row mt-3">
                                    <div class="col-12 col-sm-4">
                                        <div class="form-group">
                                            <select
                                                class="form-control form-control-color"
                                                id="keySelect"
                                                formControlName="key"
                                                [compareWith]="compareTags"
                                                (change)="onKeyChange(i)"
                                            >
                                                <option [ngValue]="null">Select Tags</option>
                                                <option *ngFor="let tag of apiResponseKeysMKS()" [ngValue]="tag" [disabled]="isKeyDisabledMKS(tag.idWithoutSite)">
                                                    {{ tag.tagName }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-7" [ngClass]="{ formgroupMobile: isMobile }">
                                        <div class="form-group autocomplete-box-mobile" *ngIf="field.get('dataType')?.value?.toLowerCase() === 'text'">
                                            <!---->
                                            <div class="form-group autocomplete-box">
                                                <div class="input-with-chips">
                                                    <div class="selected-options">
                                                        <!-- looping to show selected items -->
                                                        <!-- starting showing some badges -->

                                                        <ng-container *ngFor="let option of field.get('selectedOptions')?.value; let j = index">
                                                            <!-- displaying badge according to the maxVisibleBadges limit -->
                                                            <span
                                                                *ngIf="j < maxVisibleBadges"
                                                                class="badge badge-primary mr-1"
                                                                title="{{ option }}"
                                                                [attr.id]="'badge-option-' + j"
                                                                [attr.data-test]="'badge-option-' + j"
                                                            >
                                                                {{ option | truncate: 7 }}
                                                                <span
                                                                    class="fas fa-times-circle ml-1"
                                                                    (click)="remove(option, i)"
                                                                    [attr.id]="'remove-option-' + j"
                                                                    [attr.data-test]="'remove-option-' + j"
                                                                    style="cursor: pointer"
                                                                    >&times;</span
                                                                >
                                                            </span>
                                                        </ng-container>

                                                        <!-- show +count badges -->
                                                        <span
                                                            *ngIf="field.get('selectedOptions')?.value.length > maxVisibleBadges"
                                                            class="badge badge-secondary"
                                                            [title]="getHiddenOptionsTitle(field.get('selectedOptions')?.value)"
                                                            [attr.id]="'badges-count-' + i"
                                                            [attr.data-test]="'badges-count-' + i"
                                                        >
                                                            +{{ field.get('selectedOptions')?.value.length - maxVisibleBadges }}
                                                        </span>

                                                        <input
                                                            type="text"
                                                            class="input-box"
                                                            placeholder="Start typing..."
                                                            formControlName="optionCtrl"
                                                            (input)="filterOptions(i)"
                                                            (focus)="onFocus(i)"
                                                            (keydown.backspace)="removeLastSelected(i)"
                                                            [attr.id]="'filter-options-' + i"
                                                            [attr.data-test]="'filter-options-' + i"
                                                        />
                                                    </div>
                                                </div>

                                                <!-- dropdown with filtered options ----  field.get('filteredOptions')?.value.length > 0 -->
                                                <ul class="list-group" *ngIf="field.get('showDropdown')?.value">
                                                    <li
                                                        class="list-group-item"
                                                        *ngFor="let option of field.get('filteredOptions')?.value"
                                                        (click)="selectOption(option, i); $event.stopPropagation()"
                                                        style="cursor: pointer"
                                                        [attr.id]="'filtered-options-' + i"
                                                        [attr.data-test]="'filtered-options-' + i"
                                                    >
                                                        {{ option }}
                                                    </li>
                                                    <!-- Show 'No result found' if there are no options left after filtering -->
                                                    <li class="list-group-item disabled" *ngIf="field.get('filteredOptions')?.value.length == 0">No result found</li>
                                                </ul>
                                            </div>

                                            <!-- <ng-select
                                                [items]="apiResponse[field.get('key')?.value]?.value"
                                                [multiple]="true"
                                                bindLabel="value"
                                                formControlName="value"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select> -->
                                        </div>
                                        <div
                                            *ngIf="field.get('dataType')?.value?.toLowerCase() === 'date' || field.get('dataType')?.value?.toLowerCase() === 'datetime'"
                                            class="form-group"
                                            [ngClass]="{ 'col-11 datepicker-mobile': isMobile }"
                                        >
                                            <div class="" [ngClass]="isMobile ? 'd-flex align-items-center justify-content-between' : 'row'">
                                                <div class="col-5 col-sm-5">
                                                    <input
                                                        type="date"
                                                        class="form-control form-control-option"
                                                        id="session-date"
                                                        name="session-date"
                                                        formControlName="dateFieldFrom"
                                                        [max]="maxDateFrom"
                                                        (change)="onDateFromChange($event)"
                                                        [attr.data-test]="'from-date-' + i"
                                                    />
                                                </div>
                                                <span class="col-1 col-sm-2 to-class">To</span>
                                                <div class="col-5 col-sm-5 pl-0">
                                                    <input
                                                        type="date"
                                                        class="form-control form-control-option"
                                                        formControlName="dateFieldTo"
                                                        (change)="onDateToChange($event)"
                                                        [min]="minDateTo"
                                                        [attr.id]="'to-date-' + i"
                                                        [attr.data-test]="'to-date-' + i"
                                                    />
                                                </div>
                                            </div>
                                            <!-- <input type="date" class="form-control" id="dateInput" formControlName="value" /> -->
                                        </div>
                                        <div
                                            class="col-1 my-knowledge-store-delete-icon ml-2"
                                            *ngIf="shouldShowDeleteButton(i) && isMobile"
                                            [attr.id]="'remove-field-' + i"
                                            [attr.data-test]="'remove-field-' + i"
                                            (click)="removeFormField(i)"
                                        ></div>
                                    </div>
                                    <div class="col-1 col-sm-1" *ngIf="!isMobile">
                                        <div
                                            class="my-knowledge-store-delete-icon ml-2"
                                            *ngIf="shouldShowDeleteButton(i)"
                                            [attr.id]="'remove-field-' + i"
                                            [attr.data-test]="'remove-field-' + i"
                                            (click)="removeFormField(i)"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="modal-footer border-0" [ngClass]="{ 'save-mobile-btn': isMobile }">
        <button type="button" class="btn-custom btn-primary mr-3 mt-0 mb-2 cursor-pointer col-sm-2 float-end" (click)="saveFormToLocalStorage(selectedGyanKnowledgeStore.id)">
            Save
        </button>
    </div>
</ng-template>
